import { type FC } from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import type { HubSpotConfigurationControl, HubSpotConfigurationFormValues } from '../HubSpotConfigurationFormSchema';
import { CustomersConfigurationSection } from './sections/CustomersConfigurationSection';
import { ContractsConfigurationSection } from './sections/ContractsConfigurationSection';
import { useFetchHubSpotSettings } from '../hooks/useFetchHubSpotSettings';

type HubSpotConfigurationFormProps = {
  control: HubSpotConfigurationControl;
};

export const HubSpotConfigurationForm: FC<HubSpotConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchHubSpotSettings();
  const { reset } = useFormContext<HubSpotConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <Stack spacing={3} sx={{ p: 3 }}>
      <Typography variant="h5">Configurations</Typography>

      <Stack spacing={3.75}>
        <CustomersConfigurationSection control={control} defaultValues={configuration} />
        <Divider />
        <ContractsConfigurationSection control={control} defaultValues={configuration} />
      </Stack>
    </Stack>
  );
};
